<template>
    <section class="gmp-section gmp-mb-l">

        <div class="subpage-hero">
            <div class="two-column-tout">
                <div class="h-c-page">
                    <div class="h-c-grid">
                        <div class="h-c-grid__col h-c-grid__col-xl--offset-1 h-c-grid__col-l--6 h-c-grid__col-xl--5  h-c-grid__col--align-middle
            two-column-tout__content">
                            <h1 class="h-c-headline h-c-headline--display-two h-has-bottom-margin">
                                降低运营成本
                            </h1>
                            <div class="h-u-mb-std two-column-tout__description">
                                <p>
                                    充分利用中央厨房的设备和人力资源，最大化生产能力，以应对多渠道、多品类订单的需求。
                                </p>
                            </div>

                        </div>

                        <div class="h-c-grid__col  h-c-grid__col-l--6  h-c-grid__col--align-middle">
                            <div class="two-column-tout__image text-center">
                                <picture>
                                    <img src="@/assets/img/ds_lingxian.png" alt="" class="gmp-no-grab ">
                                </picture>
                            </div>
                        </div>

                    </div>
                </div>
            </div>


        </div>

    </section>
</template>

<script>
    export default {
        name: "CK_subpagehero"
    }
</script>

<style lang="less">


</style>